import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaytaximumbaitopune() {



  const cardData = {


  keyword: "One Way Taxi Mumbai to Pune",

  headingDescription: "Trustline Cab provides reliable one way taxi services from Mumbai to Pune with safe, comfortable, and affordable transportation for business travelers, corporate professionals, airport transfers, families, and outstation passengers. Our Mumbai to Pune one-way cab service allows you to pay only for your travel without any return fare, making it a convenient and economical option. Whether you need pickup from Mumbai Airport, railway station, hotel, office, or any location in Mumbai, our professional chauffeurs ensure timely pickup, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey to Pune. Choose from our fleet of AC Sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and premium cars with transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible schedules, and 24/7 customer support.",

  topPlaces: [
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a leading industrial and commercial region famous for automobile industries, manufacturing companies, engineering businesses, and corporate establishments."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly developing Pune suburb offering residential projects, commercial complexes, restaurants, educational institutions, and easy connectivity to Hinjewadi IT Park."
    },
    {
      title: "Baner",
      description: "Baner is a premium commercial and residential locality known for IT offices, business parks, cafés, restaurants, educational institutions, and modern infrastructure."
    },
     {
      title: "Hinjewadi",
      description: "Hinjewadi is Pune's biggest IT and corporate destination, featuring Rajiv Gandhi Infotech Park, multinational companies, software firms, and business campuses. It is one of the most popular destinations for Mumbai to Pune one-way taxi travelers."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major Pune business hub known for EON IT Park, corporate offices, technology companies, hotels, and commercial spaces. It attracts thousands of professionals and business visitors."
    },
   
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a modern integrated township featuring IT parks, corporate offices, shopping destinations, residential communities, and lifestyle facilities. It is a preferred location for business travelers."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is a major transportation hub connecting Pune with various Indian cities. Many passengers choose one-way taxi services for convenient airport transfers from Mumbai."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic Pune landmark known for its beautiful architecture, gardens, and connection with India's freedom movement. It is a popular tourist destination."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, caves, viewpoints, and lush green valleys. It is a popular stop during Mumbai-Pune journeys."
    },
    {
      title: "Pawna Lake",
      description: "Pawna Lake is a beautiful getaway near Pune known for camping, boating, mountain views, and peaceful surroundings. It is a favorite destination for weekend travelers."
    }
  ],






"services": [
  {
    "name": "Mumbai to Pune Cab",
    "description": "Book Mumbai to Pune Cab for safe and comfortable intercity travel with professional chauffeurs, clean AC Sedan, Ertiga, Innova, and Innova Crysta vehicles. Enjoy fixed fares, doorstep pickup, online booking, luggage assistance, corporate travel, family trips, airport transfers, one way and round trip cab options with reliable 24x7 customer support."
  },
  {
    "name": "Mumbai Airport to Pune Cab",
    "description": "Reserve Mumbai Airport to Pune Cab for convenient airport transfers with punctual pickup, experienced drivers, sanitized AC vehicles, fixed pricing, luggage support, and comfortable travel from Mumbai Airport to Pune."
  },
  {
    "name": "Mumbai to Pune Taxi",
    "description": "Choose Mumbai to Pune Taxi service for affordable outstation travel with professional chauffeurs, well-maintained cars, transparent pricing, flexible pickup locations, and smooth highway journeys."
  },
  {
    "name": "Mumbai to Pune Cab Price",
    "description": "Check Mumbai to Pune Cab Price with transparent fares, multiple vehicle options, affordable packages, no hidden charges, and easy booking for Sedan, Ertiga, Innova, and premium cars."
  },
  {
    "name": "Mumbai to Pune Cab Service",
    "description": "Our Mumbai to Pune Cab Service provides reliable one way and round trip transportation with experienced drivers, AC vehicles, doorstep pickup, online booking, and 24x7 travel assistance."
  },
  {
    "name": "Mumbai to Pune Taxi Price",
    "description": "Get Mumbai to Pune Taxi Price details with fixed rates, comfortable vehicles, professional chauffeurs, and affordable travel solutions for business and family journeys."
  },
  {
    "name": "Mumbai Pune Car Rental",
    "description": "Book Mumbai Pune Car Rental services with chauffeur-driven vehicles, flexible rental options, clean AC cars, corporate travel solutions, and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai Pune Cab One Way",
    "description": "Book Mumbai Pune Cab One Way for direct travel with affordable fares, instant confirmation, professional drivers, and comfortable doorstep pickup and drop services."
  },
  {
    "name": "Mumbai to Pune Cab From Airport",
    "description": "Travel from Mumbai Airport to Pune with reliable cab services offering fixed fares, airport pickup, premium vehicles, experienced chauffeurs, and hassle-free transfers."
  },
  {
    "name": "Pune to Mumbai Taxi One Way",
    "description": "Choose Pune to Mumbai Taxi One Way for affordable single-trip travel with clean AC vehicles, professional drivers, flexible pickup timing, and smooth highway journeys."
  },
  {
    "name": "Cab for Mumbai to Pune",
    "description": "Hire a Cab for Mumbai to Pune travel with Sedan, Ertiga, Innova, and SUV options, transparent pricing, experienced chauffeurs, and comfortable outstation transportation."
  },
  {
    "name": "Cab Service Mumbai to Pune",
    "description": "Book Cab Service Mumbai to Pune for reliable intercity travel with doorstep pickup, sanitized vehicles, fixed fares, online booking, and professional customer support."
  },
  {
    "name": "Mumbai Pune Cab Fare",
    "description": "Check Mumbai Pune Cab Fare with affordable pricing, multiple car choices, transparent packages, and comfortable travel options for every requirement."
  },
  {
    "name": "Mumbai International Airport to Pune Cab",
    "description": "Reserve Mumbai International Airport to Pune Cab with 24x7 airport pickup, professional chauffeurs, premium AC vehicles, luggage assistance, and safe highway travel."
  },
  {
    "name": "Cab Booking Mumbai to Pune",
    "description": "Complete Cab Booking Mumbai to Pune online with instant confirmation, secure reservations, multiple vehicle options, fixed fares, and reliable outstation cab services."
  },
  {
    "name": "Mumbai to Pune One Way Taxi",
    "description": "Book Mumbai to Pune One Way Taxi for affordable single-trip travel with comfortable AC cars, experienced drivers, doorstep pickup, and transparent pricing."
  },
  {
    "name": "Mumbai to Pune One Way Cab",
    "description": "Choose Mumbai to Pune One Way Cab for hassle-free travel with fixed fares, professional chauffeurs, Sedan, Ertiga, Innova options, and smooth destination drop."
  },
  {
    "name": "One Way Taxi Mumbai to Pune",
    "description": "Reserve One Way Taxi Mumbai to Pune for direct point-to-point travel with clean vehicles, affordable rates, online booking, and experienced drivers."
  },
  {
    "name": "Mumbai to Pune One Way Cab Service",
    "description": "Our Mumbai to Pune One Way Cab Service offers reliable single-trip transportation with AC vehicles, fixed pricing, doorstep pickup, and professional chauffeur support."
  },
  {
    "name": "Mumbai to Pune One Way Taxi Fare",
    "description": "Check Mumbai to Pune One Way Taxi Fare with transparent pricing, affordable packages, and multiple vehicle choices including Sedan, Ertiga, and Innova."
  },
  {
    "name": "One Way Cab from Mumbai to Pune",
    "description": "Book One Way Cab from Mumbai to Pune for comfortable travel with professional drivers, clean AC vehicles, flexible pickup locations, and reliable service."
  },
  {
    "name": "Mumbai to Pune One Way Taxi Booking",
    "description": "Complete Mumbai to Pune One Way Taxi Booking online with instant confirmation, secure payment options, fixed fares, and 24x7 availability."
  },
  {
    "name": "Cheap One Way Cab Mumbai to Pune",
    "description": "Hire Cheap One Way Cab Mumbai to Pune with affordable rates, well-maintained vehicles, experienced chauffeurs, and comfortable long-distance travel."
  },
  {
    "name": "Mumbai to Pune One Way Taxi Price",
    "description": "Get Mumbai to Pune One Way Taxi Price details with transparent charges, flexible packages, and reliable cab options for business and personal trips."
  },
  {
    "name": "Mumbai to Pune Single Trip Cab",
    "description": "Book Mumbai to Pune Single Trip Cab for direct travel with private vehicles, professional chauffeurs, affordable pricing, and convenient pickup services."
  },
  {
    "name": "Mumbai to Pune One Side Taxi",
    "description": "Choose Mumbai to Pune One Side Taxi for comfortable one-way transportation with fixed fares, AC vehicles, and experienced drivers."
  },
  {
    "name": "Book One Way Taxi Mumbai to Pune",
    "description": "Book One Way Taxi Mumbai to Pune online for quick confirmation, premium vehicles, affordable pricing, and reliable outstation travel."
  },
  {
    "name": "Mumbai to Pune One Way Outstation Cab",
    "description": "Reserve Mumbai to Pune One Way Outstation Cab for safe highway journeys with professional chauffeurs, clean vehicles, and transparent pricing."
  },
  {
    "name": "Mumbai to Pune One Way AC Taxi",
    "description": "Travel comfortably with Mumbai to Pune One Way AC Taxi featuring air-conditioned vehicles, affordable fares, professional drivers, and smooth travel experience."
  },
  {
    "name": "Mumbai to Pune One Way Cab Online",
    "description": "Book Mumbai to Pune One Way Cab Online with instant reservation, multiple vehicle options, fixed pricing, and reliable 24x7 customer assistance."
  }
],

"tableData": [
  ["Mumbai to Pune Cab", "Mumbai Airport to Pune Cab"],
  ["Mumbai to Pune Taxi", "Mumbai to Pune Cab Price"],
  ["Mumbai to Pune Cab Service", "Mumbai to Pune Taxi Price"],
  ["Mumbai Pune Car Rental", "Mumbai Pune Cab One Way"],
  ["Mumbai to Pune Cab From Airport", "Pune to Mumbai Taxi One Way"],
  ["Cab for Mumbai to Pune", "Cab Service Mumbai to Pune"],
  ["Mumbai Pune Cab Fare", "Mumbai International Airport to Pune Cab"],
  ["Cab Booking Mumbai to Pune", "Mumbai to Pune One Way Taxi"],
  ["Mumbai to Pune One Way Cab", "One Way Taxi Mumbai to Pune"],
  ["Mumbai to Pune One Way Cab Service", "Mumbai to Pune One Way Taxi Fare"],
  ["One Way Cab from Mumbai to Pune", "Mumbai to Pune One Way Taxi Booking"],
  ["Cheap One Way Cab Mumbai to Pune", "Mumbai to Pune One Way Taxi Price"],
  ["Mumbai to Pune Single Trip Cab", "Mumbai to Pune One Side Taxi"],
  ["Book One Way Taxi Mumbai to Pune", "Mumbai to Pune One Way Outstation Cab"],
  ["Mumbai to Pune One Way AC Taxi", "Mumbai to Pune One Way Cab Online"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable One Way Taxi Mumbai to Pune",
    WhyChoosedescription: "Trustline Cab provides convenient one-way taxi services from Mumbai to Pune with professional drivers, comfortable vehicles, and hassle-free intercity travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Get pickup from Mumbai Airport, railway stations, hotels, offices, residential areas, and any preferred location with direct drop at your Pune destination."
  },
  {
    WhyChooseheading: "No Return Fare for One Way Trips",
    WhyChoosedescription: "Travel economically with one-way taxi options designed for passengers who need a direct Mumbai to Pune journey without booking a return trip."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Travel",
    WhyChoosedescription: "Our skilled chauffeurs ensure a comfortable and secure ride with excellent knowledge of Mumbai-Pune Expressway and highway routes."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your comfort, luggage, and passenger requirements."
  },
  {
    WhyChooseheading: "Transparent One Way Taxi Fare",
    WhyChoosedescription: "Get clear pricing details before booking with competitive fares and complete transparency without hidden charges."
  },
  {
    WhyChooseheading: "Ideal for Airport, Corporate & Family Travel",
    WhyChoosedescription: "Our one-way Mumbai to Pune taxis are suitable for airport transfers, business meetings, family trips, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Taxi Booking Support",
    WhyChoosedescription: "Book your Mumbai to Pune one-way taxi anytime with instant confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide one-way taxi from Mumbai to Pune?",
    answer: "Yes, Trustline Cab offers reliable one-way taxi services from Mumbai to Pune with flexible pickup and direct drop options."
  },
  {
    question: "Can I book a one-way taxi without a return trip?",
    answer: "Yes, one-way taxi booking allows you to travel from Mumbai to Pune without paying for a return journey."
  },
  {
    question: "Which locations in Mumbai are covered for pickup?",
    answer: "We provide pickup from Mumbai Airport, Andheri, Bandra, Borivali, Thane, Navi Mumbai, Powai, Chembur, and other Mumbai locations."
  },
  {
    question: "Which vehicles are available for Mumbai to Pune one-way taxi?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is one-way taxi Mumbai to Pune available 24 hours?",
    answer: "Yes, our one-way taxi service operates 24/7 according to your preferred travel timing."
  },
  {
    question: "Can I book a Mumbai Airport to Pune one-way taxi?",
    answer: "Yes, airport pickup from Mumbai Terminal 1 and Terminal 2 to Pune is available with one-way taxi service."
  },
  {
    question: "Are toll and parking charges included in the one-way fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Should I book my Mumbai to Pune taxi in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "Do you provide one-way taxis for corporate travel?",
    answer: "Yes, our one-way taxi services are suitable for corporate executives, business meetings, employee travel, and client visits."
  },
  {
    question: "How can I book One Way Taxi Mumbai to Pune with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Verma",
    feedback: "The one-way taxi service from Mumbai to Pune was excellent. The driver arrived on time, the cab was clean, and the complete journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Deshmukh",
    feedback: "Trustline Travels provided a hassle-free one-way travel experience. The booking process was easy, the driver was professional, and we reached Pune safely and comfortably.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Taxi Mumbai to Pune",
  "image": "https://www.trustlinetravels.com/assets/images/one-way-taxi-mumbai-to-pune.webp",
  "description":
    "Book One Way Taxi Mumbai to Pune with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way cabs from Mumbai, Mumbai Airport, and all major locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at the best fares.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/one-way-taxi-mumbai-to-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>One Way Taxi Mumbai to Pune | Cab Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book One Way Taxi Mumbai to Pune with Trustline Travels for reliable one-way cab services. Get affordable taxis from Mumbai, Mumbai Airport, and all major locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Mumbai to Pune Cab, mumbai airport to pune cab, mumbai to pune taxi, mumbai to pune cab price, mumbai to pune cab service, mumbai to pune taxi price, mumbai pune car rental, mumbai pune cab one way, mumbai to pune cab from airport, pune to mumbai taxi one way, cab for mumbai to pune, cab service mumbai to pune, mumbai pune cab fare, mumbai international airport to pune cab, one way taxi mumbai to pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/15.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaytaximumbaitopune;